import {createSlice} from '@reduxjs/toolkit';

import {
    getEventsDayOverviewData,
    setSelectedDate,
} from './day-overview-actions';
import {dayOverviewEventsAdapter} from 'pages/event-management/store/day-overview-adapters';

export interface DayOverviewState {
    counts: {
        blackouts: number;
        dailyEvents: number;
        monthly: number;
        transientAirport: number;
    };
    error: boolean;
    events: ReturnType<typeof dayOverviewEventsAdapter.getInitialState>;
    isLoading: boolean;
    selectedDate: string;
}

export const initialState: DayOverviewState = {
    counts: {
        blackouts: 0,
        dailyEvents: 0,
        monthly: 0,
        transientAirport: 0,
    },
    error: false,
    events: dayOverviewEventsAdapter.getInitialState(),
    isLoading: false,
    selectedDate: '',
};

const dayOverviewSlice = createSlice({
    name: 'events/day-overview',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setSelectedDate, (state, {payload}) => {
                state.selectedDate = payload;
            })
            .addCase(getEventsDayOverviewData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getEventsDayOverviewData.fulfilled, (state, {payload}) => {
                const {counts, events} = payload;

                state.counts = counts;
                dayOverviewEventsAdapter.setAll(state.events, events);

                state.isLoading = false;
            })
            .addCase(getEventsDayOverviewData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = true;
            });
    },
});

export default dayOverviewSlice.reducer;
